import { globalThis } from './commons.js';
import { assert } from './error/assert.js';

globalThis.assert = assert;
